import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  REMOVE_MODES
} from "@/shared/constants/FormConstants";
import { ListService } from "@/modules/List/services/ListService";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { Http } from "@status/codes";
import Snackbar from "../Snackbar/Snackbar";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { List } from "@/modules/List/models/List";
import { Option } from "@/modules/List/models/Option";

Vue.use(Vuetify);
@Component({
  name: "ObservationModal"
})
export default class ObservationModal extends Vue {
  @Inject() listService!: ListService;
  @Prop() private dialogObservation = false;
  @Prop() private observationModalText!: string;
  @Prop() private observationModalTitle!: string;
  @Prop() private mode!: string;
  @Prop() private state!: boolean;

  textObservation = "";
  newReason = "";
  isNewReason = false;
  newState = true;

  requiredField = [FORM_VALIDATORS.REQUIRED_FIELD];
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  terBtnClass = STYLE_CLASSES.TERTIARY_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  cardClass = STYLE_CLASSES.CARD;
  switchClass = STYLE_CLASSES.SWITCH;

  selectOptionList: string[] = [];
  deleteOptionList: List = {} as List;

  FORM_MESSAGES = FORM_MESSAGES.SELECT_OPTION;
  NEW_REASON = FORM_MESSAGES.NEW_REASON;
  NEW_REASON_TEXT = FORM_MESSAGES.NEW_REASON_TEXT;
  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  ACCEPT_BTN = FORM_CONSTANTS.BUTTON.ACCEPT;
  ENABLE_TEXT = FORM_CONSTANTS.ENABLE_TEXT;
  DISABLE_TEXT = FORM_CONSTANTS.DISABLE_TEXT;
  DISABLED_TEXT = FORM_CONSTANTS.DISABLED_TEXT;
  NOT_USED_DOCUMENT = FORM_MESSAGES.NOT_USED_DOCUMENT;
  DELETE_MODE = REMOVE_MODES.DELETE;
  DISABLE_MODE = REMOVE_MODES.DISABLE;
  CANCEL_TITLE = FORM_MESSAGES.CANCEL_MODAL.TITLE;

  async mounted() {
    await this.getDeleteReasons();
  }

  @Watch("state", { deep: true })
  changeState() {
    this.newState = this.state ? true : false;
  }

  @Watch("textObservation")
  dataChanged() {
    if (this.textObservation === GENERAL_CONSTANTS.EXTRA_OPTION) {
      this.isNewReason = true;
    } else {
      this.isNewReason = false;
    }
  }

  async accept() {
    if (this.mode === REMOVE_MODES.DELETE)
      return this.$emit("observationModalAccept");
    if (this.textObservation === "" && this.newReason === "")
      return this.$emit("observationModalAccept", "");

    const accept = await this.updateDeleteReasonList();
    await this.getDeleteReasons();

    if (accept) {
      if (this.isNewReason) {
        this.$emit("observationModalAccept", this.newReason);
      } else {
        this.$emit("observationModalAccept", this.textObservation);
      }
      this.textObservation = "";
      this.newReason = "";
      this.isNewReason = false;
    }
  }

  cancel() {
    this.newReason = "";
    this.isNewReason = false;
    this.textObservation = "";
    this.$emit("observationModalCancel");
  }

  async getDeleteReasons() {
    try {
      const responseData = await this.listService.getListDataByName(
        GENERAL_CONSTANTS.DELETE_REASON_LIST_NAME
      );

      if (responseData.code === Http.Found && responseData.data) {
        this.deleteOptionList = responseData.data;
        this.selectOptionList = this.deleteOptionList.options.map(
          option => option.title
        );
        this.selectOptionList.push(GENERAL_CONSTANTS.EXTRA_OPTION);
      } else {
        Snackbar.popInfo(
          FORM_CONSTANTS.SNACKBAR_MESSAGES.DELETE_REASONS_NOT_FOUND
        );
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async updateDeleteReasonList(): Promise<boolean> {
    if (
      this.isNewReason &&
      this.selectOptionList.findIndex(
        item => this.newReason.toLowerCase() === item.toLowerCase()
      ) === -1
    ) {
      try {
        this.addNewOptionToList();

        if (this.deleteOptionList._key != undefined) {
          const responseData = await this.listService.updateList(
            this.deleteOptionList._key,
            this.deleteOptionList
          );

          if (responseData.code === Http.Ok) {
            return true;
          } else {
            Snackbar.popError(
              LIST_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_DELETE_LIST
            );
          }
        } else {
          Snackbar.popError(
            LIST_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_DELETE_LIST
          );
        }
        return false;
      } catch (error) {
        const errorMessage =
          (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
            ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.PUT}`
            : LIST_CONSTANTS.DIALOG_MESSAGE.ERROR_SAVE_DELETE_LIST;

        Snackbar.popError(errorMessage);
        return false;
      }
    } else {
      return true;
    }
  }

  addNewOptionToList() {
    const newOption: Option = {
      title: this.newReason,
      value: this.newReason,
      enabled: true,
      score: 0,
      uiSetup: {
        iconUrl: ""
      }
    };
    this.deleteOptionList.options.push(newOption);
  }
}
